import { destroy, get, getOne, post, put } from "../apis/httpClient";

export const pagingMenu = (params) => get('/api/v1/menu/paging',params)
export const detailMenu = (query)=>getOne(`/api/v1/menu/detail/${query}`)
export const updateMenu = (body)=>put(`/api/v1/menu/update`,body)
export const createMenu = (body)=>post(`/api/v1/menu/create`,body)
export const deleteMenu = (body) => destroy(`/api/v1/menu/delete`,body)